/**
 * Application scripts
 * Usage: Add imports here for third party scripts, such as GSAP
 *
 * Example: import { gsap } from gsap;
 */
import { gsap } from './app/gsap';
import { ScrollTrigger } from './app/ScrollTrigger.js';
import { ScrollSmoother } from './app/ScrollSmoother.js';
import { ScrollToPlugin } from './app/ScrollToPlugin.js';
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

if (
	!document.body.classList.contains('page-template-page-ticket-calendar') &&
	!document.body.classList.contains(
		'page-template-page-ots-ticket-calendar-gold'
	) &&
	!document.body.classList.contains('page-template-page-ots-ticket-calendar')
) {
	ScrollSmoother.create({
		smooth: 1,
		effects: true,
		smoothTouch: 0.3,
	});

	if (document.querySelector('.site-monopoly-background')) {
		document
			.querySelectorAll('.site-monopoly-background')
			.forEach((_sel) => {
				ScrollTrigger.create({
					trigger: _sel,
					pin: true,
					pinSpacing: false,
					endTrigger: 'body',
					start: 'top top',
					end: 'bottom bottom',
				});
			});
	}
}

if (document.querySelector('.site-monopoly-board-cards')) {
	const cards = gsap.utils.toArray('.site-monopoly-board-cards__card');
	cards.forEach((card) => {
		card.classList.add('fade-in-up');
		ScrollTrigger.batch(card, {
			batchMax: 1,
			onEnter: (batch) =>
				gsap.to(batch, {
					opacity: 1,
					y: 0,
					stagger: 1,
					overwrite: true,
				}),
		});
	});
}

if (document.querySelector('.site-colour-block')) {
	const groups = gsap.utils.toArray('.wp-block-group');
	groups.forEach((group) => {
		const groupChildren = gsap.utils.toArray(
			'*:not(.site-monopoly-board-cards__card-inner):not(.site-monopoly-board-cards__card-front):not(.site-monopoly-board-cards__card-back):not(.site-alternating-galleries):not(.site-alternating-galleries *):not(#dmn-partner-widget *):not([rel="stylesheet"])',
			group
		);

		groupChildren.forEach((_gc) => {
			_gc.classList.add('fade-in-up');
		});
		ScrollTrigger.batch(groupChildren, {
			batchMax: 1,
			onEnter: (batch) =>
				gsap.to(batch, {
					opacity: 1,
					y: 0,
					stagger: 1,
					overwrite: true,
				}),
		});
	});
}

function alternatingGalleries(_elem, columns = 2) {
	// Target the gallery images
	const galleryImages = document.querySelectorAll(_elem + ' figure');
	const images = [];
	galleryImages.forEach((image, index) => {
		const halfWidth = window.innerWidth / columns / 2;
		let moveDirection;

		// Determine the row based on the index and the number of columns
		const row = Math.floor(index / columns);
		// Alternate the direction for the entire row
		// Rows with an even number (including the first row) move in one direction
		// Rows with an odd number move in the opposite direction
		if (row % 2 === 0) {
			moveDirection = halfWidth; // Move right for even rows
		} else {
			moveDirection = -halfWidth; // Move left for odd rows
		}

		let nextImage = galleryImages[0];
		if (galleryImages[index + 1]) {
			nextImage = galleryImages[index + 1];
		}
		images.push(nextImage.querySelector('img').src);

		const tl = gsap.timeline();
		tl.from(image, {
			x: moveDirection,
			duration: 5,
			ease: 'none',
		}).to(image, {
			x: -moveDirection,
			duration: 5,
			ease: 'none',
		});

		ScrollTrigger.create({
			trigger: image,
			animation: tl,
			start: 'top bottom',
			end: 'bottom top',
			scrub: 1,
		});
	});

	let cssStr = '';
	for (let i = 0; i < images.length; i++) {
		cssStr += `${_elem} figure:nth-child(${
			i + 1
		}):before { background-image:url(${images[i]}); }`;
	}
	cssStr += `${_elem} figure:last-child:after { background-image:url(${images.pop()}); }`;
	const css = document.createElement('style');
	css.innerHTML = cssStr;
	document.body.appendChild(css);

	// Adjust gallery grid based on columns
	document.querySelectorAll(_elem).forEach((gallery) => {
		gallery.style.setProperty('--columns', columns);
	});
}

if (document.querySelector('.site-alternating-galleries')) {
	alternatingGalleries('.site-alternating-galleries > .wp-block-gallery');
}

function animatedTicker() {
	const tickerInner = document.querySelector(
		'.site-info-ticker-banner__inner'
	);
	const tickerContent = document.querySelector(
		'.site-info-ticker-banner__inner-content'
	);
	const contentWidth = tickerContent.offsetWidth;

	function animateTicker() {
		gsap.to(tickerInner, {
			x: () => -contentWidth,
			ease: 'none',
			duration: 10,
			repeat: -1,
			modifiers: {
				x: gsap.utils.unitize((x) => parseFloat(x) % contentWidth),
			},
		});
	}

	function tickerSize() {
		const tickerHeight = document.querySelector('.site-info-ticker-banner');
		let offsetHeight = 0;

		if (tickerHeight) {
			offsetHeight = tickerHeight.offsetHeight;
		} else {
			offsetHeight = 48;
		}
		document.documentElement.style.setProperty(
			'--info-ticker-height',
			`${offsetHeight}px`
		);
	}

	function tickerVisibility() {
		const infoTicker = document.querySelector('.site-info-ticker-banner');
		const infoTickerOffsetTop = infoTicker.offsetTop;
		const infoTickerHeight = infoTicker.offsetHeight;
		const infoTickerBottom = infoTickerOffsetTop + infoTickerHeight;

		if (window.scrollY >= infoTickerBottom) {
			infoTicker.classList.add('site-info-ticker-banner--is-visible');
		} else {
			infoTicker.classList.remove('site-info-ticker-banner--is-visible');
		}
	}

	animateTicker();
	setTimeout(function () {
		tickerSize();
	}, 100);
	window.addEventListener('resize', () => {
		tickerSize();
		tickerVisibility();
	});
	window.addEventListener('scroll', tickerVisibility);
}

if (document.querySelector('.site-info-ticker-banner')) {
	animatedTicker();
}
